module.exports = __webpack_public_path__ + "img/Slide29.ee5a566b.png";